



















































































































import {Vue, Component, PropSync, Watch} from 'vue-property-decorator';
import proxySettingsForm from "@/pages/Pages/Push/proxySettingsForm.vue";
import {SelectWings, InputWings} from "wings-ui-components";
import {RuStoreType} from "@/store/push/application/types";

@Component({components: {SelectWings, proxySettingsForm, InputWings}})
export default class RuStoreSettings extends Vue {
  @PropSync('rustoreOptions') rustore!: RuStoreType;

  private serverTypeList: string[] = ['PRODUCTION', 'SIMULATOR']
  private isProxySettings: boolean = false;

  created() {
    if(this.rustore.proxy_settings_name) this.isProxySettings = true;
  }

  @Watch('isProxySettings')
  onChangeProxy(newValue: boolean) {
    if (!newValue) this.rustore.proxy_settings_id = undefined;
  }
}
